import { combineReducers } from 'redux';

import data from './data';
import item from './item';

export default combineReducers({
    data,
    item
});
